import React from "react";
import styled from "styled-components";
import {
  FlexColumnContainer,
} from "@trailhead/core-ui";
import { colors } from "@trailhead/asurion-ui";

import { breakpoints, Text } from "@trailhead/asurion-ui";

import { PossibleOS } from "../../utils";
import { CardType } from "../../types";
import { CustomButton } from "../customButtons";

const AppCTAContainer = styled.div`
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: ${colors.neutralBrightest};
  border: 1px solid ${colors.neutralBright};

  ${breakpoints.md2} {
    max-height: 18.75rem;
    justify-content: space-between;
    flex-direction: row;
  }
`;

const CallToAction = styled(FlexColumnContainer)`
  align-items: left;
  padding: 2rem 1rem;

  ${breakpoints.sm} {
    padding: 2rem;
  }

  ${breakpoints.md} {
    max-width: 25rem;
  }
`;

const CallToActionHeader = styled(Text)`
  font-size: 2rem;

  ${breakpoints.md} {
    font-size: 2.5rem;
  }
`;

const CallToActionSubHeader = styled(Text)`
  text-align: left;
  margin-top: 1rem;
`;

const ImageWrapper = styled.div`
  padding: 0;
  text-align: center;
  border-radius: 0.5rem;
  overflow: hidden;

  & > img {
    height: 100%;
    max-height: 200px;

    ${breakpoints.md2} {
      max-height: unset;
    }

  }

  ${breakpoints.md2} {
    text-align: right;
  }
`;

const StoreCTAWrapper = styled.div`
  display: flex;
  margin-top: 1rem;
  cursor: pointer;
  gap: 0.5rem;
`;

type Props = CardType & {
  osOverride?: PossibleOS;
}

export const AppCTA: React.FC<Props> = ({
  heading, subheading, image,
  primaryCTA, secondaryCTA,
}) => (
  <AppCTAContainer>
    <CallToAction>
      <CallToActionHeader
        size={6}
        dangerouslySetInnerHTML={{ __html: heading }}
      />
      <CallToActionSubHeader
        dangerouslySetInnerHTML={{ __html: subheading }}
      />
      <StoreCTAWrapper>
        {primaryCTA && <CustomButton {...primaryCTA} />}
        {secondaryCTA && <CustomButton {...secondaryCTA} />}
      </StoreCTAWrapper>
    </CallToAction>
    <ImageWrapper>
      <img src={image} />
    </ImageWrapper>
  </AppCTAContainer>
);
